module.exports = __webpack_public_path__ + "img/LOGO_bg.c71d8c53.png";